<template>
  <div>
    <input type="hidden" :value="selectValue" />
    <el-upload
      ref="upload"
      :headers="headers"
      :accept="accept"
      :action="action"
      :file-list="fileList"
      :multiple="multiple"
      :auto-upload="autoUpload"
      :limit="limit"
      :data="data"
      :show-file-list="showFileList"
      :drag="drag"
      :list-type="listType"
      :on-change="handleChange"
      :before-upload="beforeAvatarUpload"
      :on-progress="handleProgress"
      :on-success="handleSuccess"
      :on-error="handleError"
      :on-preview="handlePreview"
      :before-remove="beforeRemove"
      :on-remove="handleRemove"
      :on-exceed="handleExceed"
      :with-credentials="true"
      >
      <!-- :before-remove="beforeRemove" -->
      <el-button v-if="!autoUpload" slot="trigger" size="small" type="primary">选取文件</el-button>
      <el-button v-if="!autoUpload" style="margin-left: 10px;" :size="buttonStyle.size" :type="buttonStyle.type" :plain="buttonStyle.plain" :round="buttonStyle.round" :icon="buttonStyle.icon" @click="submitUpload">{{buttonStyle.name}}</el-button>

      <i v-if="drag" class="el-icon-upload"></i>
      <div v-if="drag" class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>

      <el-button v-if="!disabled && !!autoUpload && !drag" :size="buttonStyle.size" :type="buttonStyle.type" :plain="buttonStyle.plain" :round="buttonStyle.round" :icon="buttonStyle.icon">{{buttonStyle.name}}</el-button>
    </el-upload>
  </div>
</template>
<script>
export default {
  name: 'pf-file-upload',
  props: {
    value: Object | Array,
    // 是否支持上传多个
    multiple: {
      type: Boolean,
      default() {
        return false
      }
    },
    // 是否自动上传
    autoUpload: {
      type: Boolean,
      default() {
        return true
      }
    },
    // 最大限制
    limit: {
      type: Number,
      default() {
        return null
      }
    },
    // 附件额外需要上传的参数
    data: {
      type: Object,
      default () {
        // eslint-disable-next-line no-new-object
        return new Object()
      }
    },
    // 是否显示列表
    showFileList: {
      type: Boolean,
      default() {
        return true
      }
    },
    drag: {
      type: Boolean,
      default() {
        return false
      }
    },
    listType: {
      type: String,
      default() {
        return 'text'
      }
    },
    // 按钮样式
    buttonStyle: {
      type: Object,
      default() {
        return {
          size: 'small',
          type: 'primary',
          plain: false,
          round: false,
          icon: 'el-icon-upload',
          name: '点击上传'
        }
      }
    },
    disabled: {type: Boolean, default: false},
    isLimit: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: ''
    },
    actionUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    selectValue: {
      get () {
        const fileList = []
        this.value.forEach(item => {
          fileList.push({
            id: item.id,
            name: item.name,
            url: `${gisserverUrl}` + item.url
          })
        })
        this.fileList = fileList
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  created() {
    debugger
    // eslint-disable-next-line valid-typeof
    if (this.data.flag === true) {
      this.action = `${dwgUrl}` + this.actionUrl
    }
  },
  data () {
    return {
      action: `${gisserverUrl}` + this.actionUrl, // this.global.server + '/api/manage/onlHallTemplateFile/uploadTemplateFile', // 上传路径
      headers: {
        token: '' // window.localStorage.getItem('govServiceManageToken')
      },
      // 上传的附件内容
      fileList: []
    }
  },
  methods: {
    // 点击上传
    submitUpload() {
      this.$refs.upload.submit()
    },
    // 文件上传之前
    beforeAvatarUpload (file) {
      this.$emit('submitUpload')
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2
      return true // true  继续执行  false  不执行上传
    },
    // 上传的时候
    handleProgress (event, file, fileList) {
      if (fileList.length > 1) {
        this.$emit('handleChangeLimit', fileList)
      }
    },
    // 上传成功
    handleSuccess (response, file, fileList) {
      const _this = this
      _this.hsResponse = response
      // 限制上传个数为1时，新上传一个文件且再次上传会覆盖前面的文件
      if (_this.isLimit) {
        _this.selectValue = []
        if (_this.hsResponse.code == '200') {
          _this.selectValue = _this.hsResponse.data
          this.$emit('handleSuccess', _this.hsResponse.data)
        }
      } else {
        if (_this.hsResponse.code == '200') {
          _this.selectValue.push(_this.hsResponse.data)
          this.$emit('handleSuccess', _this.hsResponse.data)
        }
      }
    },
    // 文件上传限制1个
    handleChange(file, fileList) {
      if (this.isLimit && fileList.length > 1) {
        fileList.splice(0, 1)
      }
    },
    // 上传失败
    handleError (err, file, fileList) {

    },
    // 点击上传的附件的时候
    handlePreview (file) {
      // file.response 服务器返回的数据内容
    },
    // 删除之前
    beforeRemove (file, fileList) {
      this.$utils.confirm('您确定要删除附件[' + file.name + ']吗？', () => {
        // const ids = file.id
        this.fileList.forEach((item, key) => {
          if (item.uid == file.uid) {
            this.fileList.splice(key, 1)
          }
        })
        this.selectValue.forEach((item, key) => {
          if (item.name == file.name) {
            this.selectValue.splice(key, 1)
          }
        })
        // deleteFile({ids:ids}).then(response=>{
        //     if(response && response.number){
        //         this.fileList.forEach((item, key)=>{
        //             if(item.id == file.id){
        //                 this.fileList.splice(key, 1)
        //             }
        //         })
        //         this.selectValue.forEach((item, key)=>{
        //             if(item.id == file.id){
        //                 this.selectValue.splice(key, 1)
        //             }
        //         })
        //     }
        // })
        return true// true  执行删除  false  不执行删除
      })
      return false
    },
    // 删除后
    handleRemove (file, fileList) {

    },
    // 文件超出个数限制时
    handleExceed (files, fileList) {
    }
  }
}
</script>

<style scoped>
  .mask{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 11;
  }
  .common-tree{
    overflow: auto;
  }
  .tree-select{
    z-index: 111;
  }
  .el-upload-list__item-name {
    font-size: 12px;
  }
</style>
